import {AnimatePresence, motion} from 'framer-motion'
import {TestimonialsSectionSliceDefaultPrimaryTestimonialsItem} from 'prismicio-types'
import {useWindowSize} from 'react-use'
import {BREAKPOINTS} from 'src/common/constants'

const variants = {
  initial: {opacity: 0.1},
  animate: {opacity: 1, transition: {delay: 0.3, duration: 0.7}, ease: 'easeInOut'},
  exit: {opacity: 0, transition: {duration: 0.5}},
}

export const TestimonialBackground = ({
  activeTab,
  testimonials,
}: {
  activeTab: number
  testimonials: TestimonialsSectionSliceDefaultPrimaryTestimonialsItem[]
}) => {
  const isMobile = useWindowSize().width < BREAKPOINTS.TABLET

  return (
    <AnimatePresence mode="sync">
      <motion.img
        className="absolute inset-0 -z-10 h-full w-full overflow-hidden object-cover"
        key={activeTab}
        src={isMobile ? testimonials[activeTab].mobile_image.url! : testimonials[activeTab].image.url!}
        variants={variants}
        initial="initial"
        animate="animate"
        exit="exit"
      />
    </AnimatePresence>
  )
}
